import React from "react";
import { Link, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import ReactGA from "react-ga";
import { useTranslation } from 'react-i18next'

import HEADER_IMAGE from "../../img/header-img.webp";
import useAnalyticsEventTracker from "../../useAnalyticsEventTracker";
import HomePageCarousel from "../Carousel/HomePageCarousel";
import config from "../../config";
import UnderMaintenance from "../under-maintenance/UnderMaintenance";
import ComingSoon from "../coming-soon/ComingSoon";
import TripWizard from "../modals/TripWizard";

ReactGA.pageview(window.location.pathname + window.location.search);

const tripData = [
  {
    title: 'Trip 1',
    shortDesc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
    linkToPost: '652772e6415b204eb4e56b9d',
    image: 'https://images.pexels.com/photos/2356045/pexels-photo-2356045.jpeg?auto=compress&cs=tinysrgb&h=220',
    alt: 'hills and mountains 1'
  },
  {
    title: 'Trip 2',
    shortDesc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
    linkToPost: '652772e6415b204eb4e56b9d',
    image: 'https://images.pexels.com/photos/2325446/pexels-photo-2325446.jpeg?auto=compress&cs=tinysrgb&h=220',
    alt: 'hills and mountains 1'
  },
  {
    title: 'Trip 3',
    shortDesc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
    linkToPost: '652772e6415b204eb4e56b9d',
    image: 'https://images.pexels.com/photos/3369102/pexels-photo-3369102.jpeg?auto=compress&cs=tinysrgb&h=220',
    alt: 'hills and mountains 1'
  }
];

const agentData = [{
  title: 'Company 1',
  shortDesc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
  linkToPost: '652772e6415b204eb4e56b9d',
  image: 'https://images.pexels.com/photos/796602/pexels-photo-796602.jpeg?auto=compress&cs=tinysrgb&h=220',
  alt: 'hills and mountains 1'
}, {
  title: 'Company 2',
  shortDesc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
  linkToPost: '652772e6415b204eb4e56b9d',
  image: 'https://images.pexels.com/photos/572056/pexels-photo-572056.jpeg?auto=compress&cs=tinysrgb&h=220',
  alt: 'hills and mountains 1'
}, {
  title: 'Company 3',
  shortDesc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
  linkToPost: '652772e6415b204eb4e56b9d',
  image: 'https://images.pexels.com/photos/669619/pexels-photo-669619.jpeg?auto=compress&cs=tinysrgb&h=220',
  alt: 'hills and mountains 1'
}]

const Landing = () => {
  const { t } = useTranslation();
  const gaEventTracker = useAnalyticsEventTracker("Homepage Discover Now");
  const isAuthenticated = useSelector(state => state?.auth?.isAuthenticated);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  if (config.comingSoon) {
    return <ComingSoon />
  }

  if (config.maintenance) {
    return <UnderMaintenance />
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <section className="landing">
      <div className="dark-overlay">
        <div className="landing-inner">
          <div className="_header_safe_tour_wrap">
            <div className="columns">
              <div className="column is-7">
                <h1 className="_header_safe_tour_heading_title">
                  {t("EYE_CATCHER_1")}<span style={{ "display": "block", fontSize: "66px", color: "#ff7b29" }}>{t("EYE_CATCHER_2")}</span>
                </h1>
                <p className="lead mb-3">
                  {t("HOME_TEXT")}
                </p>
                <button
                  className="button is-link is-large"
                  onClick={() => {
                    setIsModalOpen(true);
                    gaEventTracker("Get started - button")
                  }}
                >
                  {t("GET_STARTED")}
                  <span className="icon is-small ml-2">
                    <i className="fa fa-arrow-right"></i>
                  </span>
                </button>
                <p className="is-size-7 has-text-grey mt-1">{t("MICRO_COPY")}</p>
              </div>
              <div className="column is-5">
                <img src={HEADER_IMAGE} alt="banner" />
              </div>
            </div>
          </div>
          <HomePageCarousel
            title={t("RECENT_TRIPS")}
            desc={t("RECENT_TRIPS_DESC")}
            items={tripData}
            block='trips'
          />
          <HomePageCarousel
            title={t("TOP_AGENTS")}
            desc={t("TOP_AGENTS_DESC")}
            items={agentData}
            block='agents'
          />
        </div>
      </div>

      <div className={`modal ${isModalOpen ? 'is-active' : ''}`}>
        <div className="modal-background"></div>
        <div className="modal-content">
          <TripWizard />
        </div>
        <button className="modal-close is-large" aria-label="close" onClick={() => setIsModalOpen(false)}></button>
      </div>
    </section>
  );
};

Landing.propTypes = {
  isAuthenticated: PropTypes.bool,
};


export default Landing;
